<template>
	<el-main class="dynamic">
		<ContentNav :bannerTextIMG="require('../../assets/party/bannerText.png')" :bannerimgIMG="Url.imgUrl + this.$store.state.NavList[5].banner"></ContentNav>
		<div class="content">
			<div class="select">
				<div class="TimeOrder">
					<div>时间排序</div>
					<i :class="{'el-icon-top':true,'act':OrderIconVal==1}" @click="OrderArticles(1,true)"></i>
					<i :class="{'el-icon-bottom':true,'act':OrderIconVal==2}" @click="OrderArticles(2,false)"></i>
				</div>
				<div class="InputBox">
					<el-input placeholder="请输入文章关键字" v-model="title">
						<el-button @click="GetkeyWordArtice" slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div>
			</div>
			<div class="itemList">
				<div class="itemList-box" v-for="(x,i) in dynamics" :key="i">
					<div class="title" @click="goDetails(x.id)">{{x.title}}</div>
					<div class="box-bottom">
						<div class="articles_content">
							<div class="text">{{x.intro}}</div>
						</div>
						<div class="articles_time">
							<div class="year">{{x.publishYear}}</div>
							<div class="monthDay">{{x.publishMonthDay}}</div>
						</div>
					</div>
				</div>
				<div class="Pages">
					<el-pagination @current-change="topage" background layout="prev, pager, next" :total="pageCount"></el-pagination>
				</div>
			</div>
		</div>
		<Icongroup></Icongroup>
	</el-main>
</template>

<script>
	import ContentNav from "../../components/ContentNav";
	import Icongroup from "../../components/Icon_group"; 

	export default {
		components: {
			ContentNav,
			Icongroup
		},
		metaInfo() {
			return {
				title: `党建专题-${this.SystemOption.seoTitle ?? ''}`,
				meta: [{ // set meta
					name: 'keywords',
					content: this.SystemOption.seoKeyWord
				},{ // set meta
					name: 'description',
					content: this.SystemOption.seoDescribe
				}]
			}
		},
		data() {
			return {
				dynamics: [], //律所动态文章列表
				DesceOrder: true, //是否降序
				OrderIconVal: 0, //选中的图标值
				CurrentPage: 1, //当前页
				pageCount: 0, //总页数
				title: '',
				SystemOption: [] //SEO 配置
			};
		},
		methods: {
			goDetails(id){		
				this.$router.push({
					name: 'article-details1',
					params: {
						'id': id
					}
				});
			},
			loadSeo(){
				//获取SEO配置
				this.axios.get(this.Url.apiUrl + "SystemOption/GetSystemOption").then(res => this.SystemOption = res.data);
			},
			getArticles() {
				let that = this;
				let _t = Math.random();
				that.axios({
					type: "get",
					url: that.Url.apiUrl + "Articles/GetArticles",
					params: {
						'_': _t,
						type: 2,
						title:that.title,
						CurrentPage: that.CurrentPage,
						num: 8,
						isDesc: that.DesceOrder
					},
				}).then((res) => {
					that.dynamics = res.data.data;
					that.pageCount = Math.ceil((res.data.count / 8) * 10);
				});
			},
			//时序降序排列文章
			OrderArticles(index, val) {
				console.log(index, val)
				this.OrderIconVal = index;
				this.DesceOrder = val;
				this.DesceOrder = this.$store.state.partyOrder;
				this.getArticles();
			},
			//点击分页事件
			topage(val) {
				this.CurrentPage = val;
				this.getArticles();
			},
			//搜索文章
			GetkeyWordArtice() {
				this.CurrentPage = 1;
				this.getArticles();
			}
		},
		created() {
			//初始化路径数据
			this.$store.state.Currentposition = [{
				path: '/',
				name: '首页'
			}, {
				path: '/party.html',
				name: '党建专题'
			}]
			//获取律所动态文章列表
			this.CurrentPage = 1;
			this.getArticles();
			this.loadSeo();
		},
	};
</script>

<style lang="scss" scoped>
	.el-icon-bottom.act,
	.el-icon-top.act {
		color: #D0A971;
	}

	.content {
		position: relative;
		width: 1200px;
		display: block;
		margin: 0 auto;
		padding: 40px 0 120px 0;

		@media screen and (max-width: 768px) {
			padding: 26px 21px;
			width: 100%;
		}

		.select {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.TimeOrder {
				flex: 0 0 150px;
				display: flex;
				color: #202020;
				align-items: center;

				@media screen and (max-width: 768px) {
					display: none;
				}

				i {
					flex: 0 0 8px;
					height: 17px;
					margin: 0 10px;
					font-size: 18px;
					cursor: pointer;
				}
			}

			.InputBox {
				@media screen and (max-width: 768px) {
					width: 100%;

					input {
						width: 100%;
					}
				}
			}
		}

		.itemList {
			position: relative;
			display: block;
			width: 100%;
			margin: 20px 0 0 0;

			.itemList-box {
				border-bottom: 1px solid #d8d8d8;
				// height: 116px;
				margin: 5px 0;
				

				@media screen and (max-width: 768px) {
					overflow: hidden;
					text-overflow: ellipsis;

				}

				.title {
					color: #202020;
					font-weight: 600;
					line-height: 36px;
					cursor: pointer;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;

					@media screen and (max-width: 768px) {
						font-size: 13px;
					}
				}
				.articles_content{
					flex: 0 0 70%;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.text {
					font-size: 14px;
					color: #908c86;
					line-height: 18px;
					@media screen and (max-width: 768px) {
						font-size: 10px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}

				.box-bottom{
					display: flex;
					justify-content: space-between;
				}

				.articles_time {
					flex: 0 0 30%;
					font-size: 16px;
					text-align: right;
					color: #908c86;
					flex: 0 0 100px;
					
					.year{
						font-size: 14px;
					}
				}
			}
		}

		.Pages {
			width: 100%;
			height: 100px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.case-details {
			position: relative;
			flex: 0 0 950px;

			.title {
				font-size: 16px;
				font-weight: 600;
				color: #4b4b4b;
				text-align: center;
			}

			.infor {
				font-size: 12px;
				color: #787878;
				display: flex;
				justify-content: center;

				@media screen and (max-width: 768px) {
					justify-content: space-around;
					align-items: center;
				}

				>div {
					margin-right: 66px;

					@media screen and (max-width: 768px) {
						margin-right: 0;
					}

					i {
						margin-right: 15px;

						@media screen and (max-width: 768px) {
							margin-right: 5px;
						}
					}
				}
			}

			.text {
				font-size: 13px;
				color: #787878;
				margin-top: 18px;
				line-height: 20px;
				max-width: 100%;

				div {
					text-align: center;

					img {
						margin: 20px auto;

						@media screen and (max-width: 768px) {
							width: 100%;
						}
					}
				}

			}
		}
	}
</style>
